import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
	loadMonthlyStatistikAction,
	loadStatistikAction,
	loadVerfahrenAktionStatistikAction,
	loadZaehlblattStatistikAction,
} from './statistik.actions';
import {
	monthlyStatistikSelector,
	statistikSelector,
	verfahrenAktionStatistikSelector,
	zaehlblattStatistikSelector,
} from './statistik.selectors';
import {
	MonthlyStatistik,
	StatistikResource,
	VerfahrenAktionStatistik,
	ZaehlblattStatistikResource,
} from './statistik.model';
import { Moment } from 'moment';
import { AppState } from '../../../../apps/int-client/src/app/shared/store/app-state.model';

@Injectable({ providedIn: 'root' })
export class StatistikFacade {
	statistik: Observable<StatistikResource> = this.store.select(statistikSelector);
	monthlyStatistik: Observable<MonthlyStatistik> = this.store.select(monthlyStatistikSelector);
	zaehlblattStatistik: Observable<ZaehlblattStatistikResource> = this.store.select(zaehlblattStatistikSelector);
	verfahrenAktionStatistik: Observable<VerfahrenAktionStatistik> = this.store.select(
		verfahrenAktionStatistikSelector
	);

	constructor(private store: Store<AppState>) {}

	loadStatistik() {
		this.store.dispatch(loadStatistikAction());
	}

	loadMonthlyStatistik() {
		this.store.dispatch(loadMonthlyStatistikAction());
	}

	loadZaehlblattStatistik() {
		this.store.dispatch(loadZaehlblattStatistikAction());
	}

	loadVerfahrenAktionStatistik(von: Moment, bis: Moment) {
		this.store.dispatch(loadVerfahrenAktionStatistikAction({ von, bis }));
	}
}
